import { TextareaAutosize } from '@mui/material'
import { SuggestedAssessmentsSelectMenu } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageComponents'
import {
  PMPSectionInputLabel,
  SectionSecondaryHeadingAndContent,
} from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageStyles'

export default function SendAssessmentComponent({
  clinicId,
  clinicBrandId,
  selectedAssessments,
  setSelectedAssessments,
  notesForAssessments,
  setNotesForAssessments,
  loading,
  setLoading,
  mentorProfileData,
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <SectionSecondaryHeadingAndContent style={{ width: '100%' }}>
        <PMPSectionInputLabel main className="d-flex align-items-center gap-2">
          <div>Psych Assessments Needed</div>
        </PMPSectionInputLabel>
        <SuggestedAssessmentsSelectMenu
          clinicId={clinicId}
          clinicBrandId={clinicBrandId}
          selectedAssessments={selectedAssessments}
          setSelectedAssessments={setSelectedAssessments}
          menuPortalTarget={document.body}
          maxZIndex
          doctorSpecializations={mentorProfileData?.specializedCategories}
          //   prescriptionViewSettings={prescriptionViewSettings}
          //   recommendedAssessments={recommendedHealthEntityForDoctor?.[HE_KEY_PSYCH_ASSESSMENTS]}
        />
      </SectionSecondaryHeadingAndContent>
      {selectedAssessments?.length > 0 && (
        <SectionSecondaryHeadingAndContent>
          <PMPSectionInputLabel main className="d-flex align-items-center gap-2">
            <div>Notes for psychology for assessment</div>
          </PMPSectionInputLabel>
          <div className="w-100">
            <TextareaAutosize
              placeholder="Enter notes for the psychologists who will take the asessment..."
              className="pmpTextarea-focus pmp-rounded-box"
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #cecece',
                background: '#fff',
              }}
              value={notesForAssessments}
              onChange={(e) => {
                setNotesForAssessments(e.target.value)
              }}
            />
          </div>
        </SectionSecondaryHeadingAndContent>
      )}
    </div>
  )
}
